import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackProductRemovedFromQuickOrderParameters extends TrackEventBaseParameters {}

const trackProductRemovedFromQuickOrder = (
    parameters: TrackProductRemovedFromQuickOrderParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "product_removed_from_quick_order", ...parameters }, options);
};

export default trackProductRemovedFromQuickOrder;
